<div id="confirmModal">
  <div class="card">
    <!-- Login -->
    <div id="login" data-target-group="idForm">
      <!-- Header -->
      <header class="card-header bg-light">
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="h6 mb-0">{{ title }}</h3>

          <button *ngIf="!showSpinner && !showProgress" type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </header>
      <!-- End Header -->

      <div class="card-body">
        <div class="row p-2">
          <div class="col-md-12" [ngClass]="{ 'text-center': showSpinner }" innerHTML="{{ message }}"></div>
          <page-load-header *ngIf="showSpinner" class="mx-auto"></page-load-header>
        </div>
        <div *ngIf="showProgress" class="mb-0">
          <div class="d-flex align-items-center pb-3">
            <div *ngIf="percentage >= 0" class="progress mt-4" style="height: 20px; width: 100%">
              <div class="progress-bar bg-alternate" role="progressbar" [ngStyle]="{ width: percentage + '%' }" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">{{ percentage }}%</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!showSpinner && !showProgress" class="card-footer">
        <div class="d-flex">
          <button type="button" *ngIf="!singleButton" class="btn btn-block btn-sm btn-soft-danger transition-3d-hover mr-1" (click)="activeModal.dismiss('Cross click')">
            {{ cancel }}
          </button>
          <button *ngIf="error" type="button" class="btn btn-block btn-sm btn-soft-danger transition-3d-hover ml-1 mt-0" (click)="activeModal.close()">
            {{ ok }}
          </button>
          <button *ngIf="!error" type="button" class="btn btn-block btn-sm btn-soft-success transition-3d-hover ml-1 mt-0" (click)="activeModal.close()">
            {{ ok }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
